import React, { Component } from 'react';
import { Row, Col, Input } from 'react-materialize';
import * as _ from 'lodash';

export default class SettingsPanel extends Component {

    constructor(props){
        super(props);
    }
    onChangeLegendPosition(event){
        var val = Object.assign(this.props.legend,{position:event.target.value});
        this.props.onChangeAttribute({legend:val});
    }
    onChangeLegendWidth(event){
        var val = Object.assign(this.props.legend,{width:parseInt(event.target.value)});
        this.props.onChangeAttribute({legend:val});
    }
    onChangeLegendSort(event){
        var sort = event.target.checked ? 'reverse' : 'none';
        var val = Object.assign(this.props.legend,{sort:sort});
        this.props.onChangeAttribute({legend:val});
    }
    onChangeOrientation(event){
        this.props.onChangeAttribute({orientation:event.target.value});
    }
    onChangeAxisLabels(event){
        var value = event.target.checked;
        this.props.onChangeAttribute({axisLabels:value})
    }
    onChangeXAxis(event){
        var value = event.target.checked;
        this.props.onChangeAttribute({xAxis:value})
    }
    onChangeYAxis(event){
        var value = event.target.checked;
        this.props.onChangeAttribute({yAxis:value})
    }
    onChangeLogScale(event){
        var value = event.target.checked
        this.props.onChangeAttribute({logScale:value})
    }
    onChangeGridTop(event){
        var val = Object.assign(this.props.grid,{top:parseInt(event.target.value)})
        this.props.onChangeAttribute({grid:val});
    }
    onChangeGridBottom(event){
        var val = Object.assign(this.props.grid,{bottom:parseInt(event.target.value)})
        this.props.onChangeAttribute({grid:val});
    }
    onChangeGridLeft(event){
        var val = Object.assign(this.props.grid,{left:parseInt(event.target.value)})
        this.props.onChangeAttribute({grid:val});
    }
    onChangeGridRight(event){
        var val = Object.assign(this.props.grid,{right:parseInt(event.target.value)})
        this.props.onChangeAttribute({grid:val});
    }
    onChangeMarkLine(event){
        var type = event.target.value;
        var checked = event.target.checked;
        var value = Object.assign(this.props.marklines,{[type]:checked});
        this.props.onChangeAttribute({marklines:value});
    }
    onChangeCustomValue(event){
        var value = Object.assign(this.props.marklines,{customValue:event.target.value});
        this.props.onChangeAttribute({marklines:value});
    }
    onChangeDataZoom(event){
        this.props.onChangeAttribute({dataZoom: event.target.checked});
    }
    render(){
        return <div className="chart-editor-panel">
            {this.props.hasLegendSupport() &&
                <Row>
                    <h6><b>Legend:</b></h6>
                    <Input 
                        l={6} m={6} s={6}
                        name="legend" 
                        type="radio" 
                        label="None" 
                        value="none" 
                        checked={this.props.legend.position == 'none'}
                        className="with-gap" 
                        onChange={this.onChangeLegendPosition.bind(this)}/>
                    <Input 
                        l={6} m={6} s={6}
                        name="legend" 
                        type="radio" 
                        label="Right" 
                        value="right" 
                        checked={this.props.legend.position == 'right'}
                        className="with-gap" 
                        onChange={this.onChangeLegendPosition.bind(this)}/>
                    {this.props.legend.position != 'none' &&
                        <div>
                            <div className="col input-field s6 m6 l6">
                                <label htmlFor="legend-width" className="active">Width</label> 
                                <input
                                    id="legend-width"
                                    type="number"
                                    value={this.props.legend.width}
                                    onChange={this.onChangeLegendWidth.bind(this)}/>
                            </div>
                            <Input
                                l={8} m={8} s={8}
                                label="Reverse order"
                                type="checkbox"
                                checked={this.props.legend.sort == 'reverse'}
                                value='reverse'
                                onChange={this.onChangeLegendSort.bind(this)}/>
                        </div>
                    }
                </Row>
                }
                {this.props.hasOrientationSupport() &&
                <Row>
                    <h6><b>Orientation:</b></h6>
                    <Input 
                        l={6} m={6} s={6}
                        name="orientation" 
                        type="radio" 
                        label="Vertical" 
                        value="vertical" 
                        checked={this.props.orientation == 'vertical'}
                        className="with-gap" 
                        onChange={this.onChangeOrientation.bind(this)}/>
                    <Input 
                        l={6} m={6} s={6}
                        name="orientation" 
                        type="radio" 
                        label="Horizontal" 
                        value="horizontal" 
                        checked={this.props.orientation == 'horizontal'}
                        className="with-gap" 
                        onChange={this.onChangeOrientation.bind(this)}/>
                </Row>
                }
                    
                {this.props.hasAxisSupport() && 
                    <Row>
                        <h6><b>Axis:</b></h6>
                        <Col l={6} m={6} s={6}>Labels:</Col>
                        <Input
                            l={6} m={6} s={6}
                            type="switch"
                            label="Axis Labels"
                            offLabel=" "
                            onLabel=" "
                            checked={this.props.axisLabels}
                            onChange={this.onChangeAxisLabels.bind(this)}/>
                        <Col l={6} m={6} s={6}>X Axis:</Col>
                        <Input
                            l={6} m={6} s={6}
                            type="switch"
                            label="show xAxis"
                            offLabel=" "
                            onLabel=" "
                            checked={this.props.xAxis}
                            onChange={this.onChangeXAxis.bind(this)}/>
                        <Col l={6} m={6} s={6}>Y Axis:</Col>
                        <Input
                            l={6} m={6} s={6}
                            type="switch"
                            label="show yAxis"
                            offLabel=" "
                            onLabel=" "
                            checked={this.props.yAxis}
                            onChange={this.onChangeYAxis.bind(this)}/>

                        { this.props.hasLogSupport() &&
                            <Input
                                l={12} m={12} s={12}
                                type="checkbox"
                                label="Log scale"
                                checked={this.props.logScale}
                                onChange={this.onChangeLogScale.bind(this)}/>
                        }
                    </Row>
                }
                {this.props.hasGridSupport() && 
                    <div>
                        <Row>
                            <h6><b>Grid Margins:</b></h6>
                            <div className="col input-field s6 m6 l6">
                                <label htmlFor="grid-top" className="active">Top</label> 
                                <input
                                    id="grid-top"
                                    type="number"
                                    step="1" min="0" 
                                    value={this.props.grid.top}
                                    onChange={this.onChangeGridTop.bind(this)}/>
                            </div>
                            <div className="col input-field s6 m6 l6">
                                <label htmlFor="grid-bottom" className="active">Bottom</label> 
                                <input
                                    id="grid-bottom"
                                    type="number"
                                    step="1" min="0" 
                                    value={this.props.grid.bottom}
                                    onChange={this.onChangeGridBottom.bind(this)}/>
                            </div>
                        </Row>
                        <Row>
                            <div className="col input-field s6 m6 l6">
                                <label htmlFor="grid-left" className="active">Left</label> 
                                <input
                                    id="grid-left"
                                    type="number"
                                    step="1" min="0" 
                                    value={this.props.grid.left}
                                    onChange={this.onChangeGridLeft.bind(this)}/>
                            </div>
                            <div className="col input-field s6 m6 l6">
                                <label htmlFor="grid-right" className="active">Right</label> 
                                <input
                                    id="grid-right"
                                    type="number"
                                    step="1" min="0" 
                                    value={this.props.grid.right}
                                    onChange={this.onChangeGridRight.bind(this)}/>
                            </div>
                        </Row>
                    </div>
                }
                {this.props.hasMarkLineSupport() &&
                    <div>
                        <h6><b>Mark lines:</b></h6>
                            {this.props.includeMinMaxAvg() &&
                                <Row>
                                    <Input 
                                        label="Avg"
                                        l={6} m={6} s={6}
                                        name="markline" 
                                        type="checkbox" 
                                        value="hasAverage"
                                        checked={this.props.marklines.hasAverage}
                                        onChange={this.onChangeMarkLine.bind(this)}/>
                                    <Input 
                                        label="Min"
                                        l={6} m={6} s={6}
                                        name="markline" 
                                        type="checkbox" 
                                        value="hasMin"
                                        checked={this.props.marklines.hasMin}
                                        onChange={this.onChangeMarkLine.bind(this)}/>
                                    <Input 
                                        label="Max"
                                        l={6} m={6} s={6}
                                        name="markline" 
                                        type="checkbox" 
                                        value="hasMax"
                                        checked={this.props.marklines.hasMax}
                                        onChange={this.onChangeMarkLine.bind(this)}/>
                                </Row> 
                            }
                        <Row>
                            <Input 
                                label="Value"
                                l={6} m={6} s={6}
                                name="markline" 
                                type="checkbox" 
                                value="hasCustom"
                                checked={this.props.marklines.hasCustom}
                                onChange={this.onChangeMarkLine.bind(this)}/>
                            <Col l={12} m={12} s={12}>
                                <input
                                    value={this.props.marklines.customValue}
                                    disabled={!this.props.marklines.hasCustom}
                                    onChange={this.onChangeCustomValue.bind(this)}/>
                            </Col>
                        </Row>
                    </div>
                }
                {this.props.hasDataZoomSupport() && this.props.orientation !== 'horizontal' &&
                    <div>
                        <h6><b>Data Zoom:</b></h6>
                        <Input 
                            label="Show"
                            l={4} m={4} s={4}
                            name="datazoom" 
                            type="checkbox" 
                            value="datazoom"
                            checked={this.props.dataZoom}
                            onChange={this.onChangeDataZoom.bind(this)}/>
                    </div>
                }
            </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/chart-editor/SettingsPanel.jsx